"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeUtils = exports.TransferToSymbol = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const OrderDescUtils_1 = require("../MarketTradeDesc/OrderDescUtils");
const OrderSupportDesc_1 = require("../MarketTradeDesc/OrderSupportDesc");
const CalcProfitUtils_1 = require("../Tools/CalcProfit/CalcProfitUtils");
const OderGroupCalcProfitUtils_1 = require("../Tools/CalcProfit/OderGroupCalcProfitUtils");
const BaseTradingApi_1 = require("../TradingBot/BaseTradingApi");
const OrderFSTCalcProfitUtils_1 = require("./CalcProfit/OrderFSTCalcProfitUtils");
const FSTOrderUtils_1 = require("./ParseOrder/FSTOrderUtils");
const ParseOrderUtils_1 = require("./ParseOrder/ParseOrderUtils");
const CryptoJS = require("crypto-js");
const orderTypeEnum = {
    [TradeTypeDef_1.ExchangeOrderType.twap]: "exchangeTWAPOrder",
    [TradeTypeDef_1.ExchangeOrderType.aip]: "exchangeAIPOrder",
    [TradeTypeDef_1.ExchangeOrderType.ig]: "exchangeIGOrder",
    [TradeTypeDef_1.ExchangeOrderType.grid]: "exchangeGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.trailingStop]: "exchangeTrailingStopLimitOrder",
    [TradeTypeDef_1.ExchangeOrderType.stopLimit]: "exchangeStopLimitOrder",
    [TradeTypeDef_1.ExchangeOrderType.market]: "exchangeCustomOrder",
    [TradeTypeDef_1.ExchangeOrderType.limit]: "exchangeCustomOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridV3]: "exchangeGridV3Order",
    [TradeTypeDef_1.ExchangeOrderType.gridV4]: "exchangeGridV4Order",
    [TradeTypeDef_1.ExchangeOrderType.gridV4Futures]: "exchangeGridV4FuturesOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid]: "exchangeGridV4FuturesHedgeGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridPro]: "exchangeGridProOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridClassic]: "exchangeGridClassicOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridShort]: "exchangeShortGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridLoan]: "exchangeLoanGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridLeverage]: "exchangeLeverageGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridFuture]: "exchangeFutureGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridLeverageShort]: "exchangeLeverageShortGridOrder",
    [TradeTypeDef_1.ExchangeOrderType.SL_Pro]: "exchangeSLProOrder",
    [TradeTypeDef_1.ExchangeOrderType.smartTrade]: "exchangeSmartTradeOrder",
    [TradeTypeDef_1.ExchangeOrderType.fsa]: "exchangeFSAOrder",
    [TradeTypeDef_1.ExchangeOrderType.cm_fsa]: "exchangeCMFSAOrder",
    [TradeTypeDef_1.ExchangeOrderType.SR]: "exchangeSROrder",
    [TradeTypeDef_1.ExchangeOrderType.martingale]: "exchangeMTGOrder",
    [TradeTypeDef_1.ExchangeOrderType.SC]: "exchangeSCOrder",
    [TradeTypeDef_1.ExchangeOrderType.reverse_fsa]: "exchangeReverseFSAOrder",
    [TradeTypeDef_1.ExchangeOrderType.enhanced_aip]: "exchangeEnhancedAipOrder",
    [TradeTypeDef_1.ExchangeOrderType.order_group]: "exchangeGroupOrder",
    [TradeTypeDef_1.ExchangeOrderType.futures_smart_trade]: "exchangeFSTOrder",
    [TradeTypeDef_1.ExchangeOrderType.gridV5]: "exchangeGridV5Order",
};
const TransferToSymbol = (symbol) => {
    if (symbol.indexOf("/") >= 0) {
        const arr = symbol.split("/");
        return { base: arr[0], quote: arr[1] };
    }
    else {
        return { base: "", quote: "" };
    }
};
exports.TransferToSymbol = TransferToSymbol;
const SWAPSuffix = ".SWAP";
const CMSWAPSuffix = ".CMSWAP";
exports.TradeUtils = {
    parseDisplay(base, quote, exchange, futureTag) {
        if (base && quote && exchange) {
            let baseDisplay = base;
            let isLeverage = false;
            let isSpot = true;
            let quoteDisplay = this.parseQuoteDisplay(quote);
            let type = trade_utils_lib_1.ExchangeSymbolType.spot;
            ///> 解析派网的杠杆代币
            if (exchange === ExchangeID_1.ExchangeID.PIONEXV2) {
                if (base.match("[0-9][MP]$") !== null) {
                    isLeverage = true;
                    type = trade_utils_lib_1.ExchangeSymbolType.leveraged_coin;
                }
                baseDisplay = exports.TradeUtils.parseBaseDisplay(base);
            }
            base.endsWith(SWAPSuffix) || base.endsWith(CMSWAPSuffix);
            if (base.endsWith(SWAPSuffix)) {
                isSpot = false;
                type = trade_utils_lib_1.ExchangeSymbolType.swap_binance;
                const pos = base.indexOf(SWAPSuffix);
                if (pos >= 0) {
                    baseDisplay = base.substr(0, pos);
                }
            }
            else if (base.endsWith(CMSWAPSuffix)) {
                isSpot = false;
                type = trade_utils_lib_1.ExchangeSymbolType.cm_swap_binance;
                const pos = base.indexOf(CMSWAPSuffix);
                if (pos >= 0) {
                    baseDisplay = base.substr(0, pos);
                }
            }
            return {
                quoteDisplay,
                baseDisplay,
                isLeverage,
                isSpot,
                type,
            };
        }
        else {
            return {
                baseDisplay: base,
                isLeverage: false,
                isSpot: true,
                type: trade_utils_lib_1.ExchangeSymbolType.unknown,
            };
        }
    },
    parseQuoteDisplay(quote) {
        // 不需要转换了
        // const productType = getTradeDependencyInstance().getProductType();
        // // US站点将USDP和BUSD转换成 USD
        // // @ts-ignore
        // if ((productType === "pionex_us" || productType === PRODUCT_TYPE.PIONEX_US) && ["USDP", "BUSD"].indexOf(quote) !== -1) {
        //     return "USD";
        // }
        return quote;
    },
    parseBaseDisplay(base) {
        if (base.match("[0-9][MP]$") !== null) {
            return `${base.substr(0, base.length - 1)}${base.endsWith("P") ? "L" : "S"}`;
        }
        else if (base.startsWith("INCH") && base.endsWith(".PERP")) {
            const _base = base.split(".")[0];
            return `1${_base}`;
        }
        else if (base.startsWith("INCH")) {
            return `1${base}`;
        }
        else if (base.startsWith("HOT")) {
            return "HYDRO";
        }
        else if (base === "MBTC") {
            return "mBTC";
        }
        else if (base === "METH") {
            return "mETH";
        }
        else if (base.endsWith(".PERP")) {
            const baseStrArr = base.split(".");
            return baseStrArr.length ? baseStrArr[0] : base;
        }
        return base;
    },
    /**
     * 加载该市场相关的配置
     * @param {string} market
     * @returns {TradeExchangeInfo}
     * @private
     */
    loadTradeExchangeInfo(market) {
        if (!market) {
            return;
        }
        let marketLower = market.toLowerCase().trim();
        if (marketLower === "pionex") {
            marketLower = ExchangeID_1.ExchangeID.PIONEXV2;
        }
        if (marketLower in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
            return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLower];
        }
        throw `not support ${market} yet`;
    },
    achievePropertyExchangeOrder(order, propertyName) {
        if (propertyName in order) {
            return order[propertyName];
        }
        if (order.orderType === TradeTypeDef_1.ExchangeOrderType.limit || order.orderType === TradeTypeDef_1.ExchangeOrderType.market) {
            if (propertyName in order.exchangeCustomOrder) {
                return order.exchangeCustomOrder[propertyName];
            }
            else {
                throw "custom order has no " + propertyName + " property";
            }
        }
        else if (order.orderType === TradeTypeDef_1.ExchangeOrderType.stopLimit) {
            if (propertyName in order.exchangeStopLimitOrder) {
                return order.exchangeStopLimitOrder[propertyName];
            }
            else {
                throw "stop-limit order has no " + propertyName + " property";
            }
        }
        else if (order.orderType === TradeTypeDef_1.ExchangeOrderType.grid) {
            if (propertyName in order.exchangeGridOrder) {
                return order.exchangeGridOrder[propertyName];
            }
            else {
                throw "grid order has no " + propertyName + " property";
            }
        }
        else if (order.orderType === TradeTypeDef_1.ExchangeOrderType.gridClassic) {
            if (propertyName in order.exchangeGridClassicOrder) {
                return order.exchangeGridClassicOrder[propertyName];
            }
            else {
                throw "grid classic order has no " + propertyName + " property";
            }
        }
        else if (order.orderType === TradeTypeDef_1.ExchangeOrderType.gridPro) {
            if (propertyName in order.exchangeGridProOrder) {
                return order.exchangeGridProOrder[propertyName];
            }
            else {
                throw "grid pro order has no " + propertyName + " property";
            }
        }
    },
    calcGridOrderProfit(item, price, swapPrice, basesTickers) {
        switch (item.orderType) {
            case TradeTypeDef_1.ExchangeOrderType.grid:
            case TradeTypeDef_1.ExchangeOrderType.ig: {
                return (0, CalcProfitUtils_1._calcGridProfit)(item, price);
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV3:
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeGridV3Order.closedPrice ? item.exchangeGridV3Order.closedPrice : 0);
                }
            case TradeTypeDef_1.ExchangeOrderType.gridV4:
            case TradeTypeDef_1.ExchangeOrderType.gridV5: {
                const innerOrder = exports.TradeUtils.getInnerOrder(item);
                let tempPrice = price;
                if (!item.isRunning) {
                    tempPrice = innerOrder.closedPrice || price;
                }
                return (0, CalcProfitUtils_1._calcGridProProfit)(item, tempPrice);
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV4Futures: {
                const innerOrder = exports.TradeUtils.getInnerOrder(item);
                let tempPrice = price;
                if (!item.isRunning) {
                    tempPrice = innerOrder.closedPrice || price;
                }
                return (0, CalcProfitUtils_1._calcGridProProfit)(item, tempPrice);
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid: {
                const innerOrder = exports.TradeUtils.getInnerOrder(item);
                let tempPrice = price;
                if (!item.isRunning) {
                    tempPrice = innerOrder.closedPrice || price;
                }
                return (0, CalcProfitUtils_1._calcGridProProfit)(item, tempPrice);
            }
            case TradeTypeDef_1.ExchangeOrderType.gridPro: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeGridProOrder.closedPrice ? item.exchangeGridProOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.gridClassic: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeGridClassicOrder.closedPrice ? item.exchangeGridClassicOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.gridShort: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeShortGridOrder.closedPrice ? item.exchangeShortGridOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.gridLoan: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeLoanGridOrder.closedPrice ? item.exchangeLoanGridOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.gridLeverage: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeLeverageGridOrder.closedPrice ? item.exchangeLeverageGridOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.gridFuture: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeFutureGridOrder.closedPrice ? item.exchangeFutureGridOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.gridLeverageShort: {
                if (item.isRunning) {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, price);
                }
                else {
                    return (0, CalcProfitUtils_1._calcGridProProfit)(item, item.exchangeLeverageShortGridOrder.closedPrice ? item.exchangeLeverageShortGridOrder.closedPrice : 0);
                }
            }
            case TradeTypeDef_1.ExchangeOrderType.stopLimit: {
                item.exchangeStopLimitOrder.investment = item.exchangeStopLimitOrder.amount * item.exchangeStopLimitOrder.limit;
                if (item.exchangeStopLimitOrder.filled_value > 0) {
                    item.exchangeStopLimitOrder.profit = item.exchangeStopLimitOrder.filled_value - item.exchangeStopLimitOrder.investment;
                }
                return item;
            }
            case TradeTypeDef_1.ExchangeOrderType.trailingStop: {
                return (0, CalcProfitUtils_1._calcTrailingStopProfit)(item, price);
            }
            case TradeTypeDef_1.ExchangeOrderType.aip: {
                ///> AIP订单利润计算
                item.exchangeAIPOrder.latestPrice = price;
                item.exchangeAIPOrder.profit = item.exchangeAIPOrder.traded * price - item.exchangeAIPOrder.investment;
                item.exchangeAIPOrder.profitPercent =
                    item.exchangeAIPOrder.investment !== 0 ? (item.exchangeAIPOrder.profit / item.exchangeAIPOrder.investment) * 100 : 0;
                return item;
            }
            case TradeTypeDef_1.ExchangeOrderType.twap: {
                ///> todo: TWAP订单利润计算
                item.exchangeTWAPOrder.profit = item.exchangeTWAPOrder.traded * price - item.exchangeTWAPOrder.investment;
                return item;
            }
            case TradeTypeDef_1.ExchangeOrderType.market:
            case TradeTypeDef_1.ExchangeOrderType.limit:
            case TradeTypeDef_1.ExchangeOrderType.SL_Pro: {
                return item;
            }
            case TradeTypeDef_1.ExchangeOrderType.smartTrade: {
                return (0, CalcProfitUtils_1._calcSmartTradeProfit)(item, price);
            }
            case TradeTypeDef_1.ExchangeOrderType.fsa: {
                return (0, CalcProfitUtils_1._calcFSAProfit)(item, price, swapPrice);
            }
            case TradeTypeDef_1.ExchangeOrderType.cm_fsa: {
                return (0, CalcProfitUtils_1._calcCMFSAProfit)(item, price, swapPrice);
            }
            case TradeTypeDef_1.ExchangeOrderType.reverse_fsa: {
                return (0, CalcProfitUtils_1._calcReverseFSAProfit)(item, price, swapPrice);
            }
            case TradeTypeDef_1.ExchangeOrderType.SR: {
                return (0, CalcProfitUtils_1._calcSRProfit)(item, basesTickers);
            }
            case TradeTypeDef_1.ExchangeOrderType.martingale: {
                return (0, CalcProfitUtils_1._calcMTGProfit)(item, basesTickers);
            }
            case TradeTypeDef_1.ExchangeOrderType.SC: {
                return (0, CalcProfitUtils_1._calcSCProfit)(item, basesTickers);
            }
            case TradeTypeDef_1.ExchangeOrderType.enhanced_aip: {
                return (0, CalcProfitUtils_1._calcEnhancedAipProfit)(item, basesTickers);
            }
            case TradeTypeDef_1.ExchangeOrderType.order_group: {
                return OderGroupCalcProfitUtils_1.OderGroupCalcProfitUtils._calcOrderGroupProfit(item, basesTickers);
            }
            case TradeTypeDef_1.ExchangeOrderType.futures_smart_trade: {
                return OrderFSTCalcProfitUtils_1.OrderFSTCalcProfitUtils._calcFutureSmartTradeProfit(item, basesTickers);
            }
            default: {
                return item;
            }
        }
    },
    convertState(orderState, partialFilled) {
        if (orderState === "open" || orderState === "prepare" || orderState === "pending") {
            return TradeTypeDef_1.ExchangeOrderStatus.submitted;
        }
        else if (orderState === "closed" || orderState === "partial_filled" || (orderState === "canceled" && partialFilled)) {
            return TradeTypeDef_1.ExchangeOrderStatus.filled;
        }
        else if (orderState === "pre-cancel" || orderState === "canceling") {
            return TradeTypeDef_1.ExchangeOrderStatus.canceling;
        }
        else {
            return TradeTypeDef_1.ExchangeOrderStatus.canceled;
        }
    },
    handleState(orderState) {
        return orderState === TradeTypeDef_1.ExchangeOrderStatus.submitted || orderState === TradeTypeDef_1.ExchangeOrderStatus.canceling;
    },
    hmac(request, secret, hash = "sha256", digest = "base64") {
        const result = CryptoJS["Hmac" + hash.toUpperCase()](request, secret);
        if (digest) {
            const encoding = digest === "binary" ? "Latin1" : exports.TradeUtils.capitalize(digest);
            return result.toString(CryptoJS.enc[exports.TradeUtils.capitalize(encoding)]);
        }
        return result;
    },
    unCamelCase(s) {
        return s.match(/^[A-Z0-9_]+$/)
            ? s
            : s
                .replace(/[a-z0-9][A-Z]/g, (x) => x[0] + "_" + x[1])
                .replace(/[A-Z0-9][A-Z0-9][a-z]/g, (x) => x[0] + "_" + x[1] + x[2])
                .toLowerCase();
    },
    capitalize(s) {
        return s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    },
    random32String() {
        let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        let pwd = "";
        for (let i = 0; i < 32; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return pwd;
    },
    checkApiAccessWithBU(apiKey, ignoreKeyId) {
        if (apiKey.source === "web") {
            return true;
        }
        if ((0, OrderDescUtils_1.checkMarketAccessWithBUCloud)(apiKey.market)) {
            if (ignoreKeyId === false) {
                return true;
            }
            else {
                return apiKey.cloudKeyId && apiKey.cloudKeyId.length > 0;
            }
        }
        return false;
    },
    // 处理 多空双开网格
    gridV4FuturesHedgeGridToExchangeOrder({ data }) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
        const buOrderDataKeys = Object.keys(data.bu_order_data);
        if (buOrderDataKeys.length === 0) {
            return undefined;
        }
        function formatTrendOrderData(value, trend) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            if (!value.bu_order_data) {
                return;
            }
            const baseAmountD = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.base_amount);
            let avgOpenPrice = 0;
            if (baseAmountD.eq(0) === false) {
                const openPrice = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.position_open_price);
                const invest = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.quote_investment);
                const extraMargin = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.extra_margin);
                const marginBalance = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.margin_balance);
                avgOpenPrice = invest.add(extraMargin).sub(marginBalance).div(baseAmountD).add(openPrice).toNumber();
            }
            return Object.assign(Object.assign({}, (0, ParseOrderUtils_1._convertGridV3ToInnerOrderInfo)(Object.assign(Object.assign({}, value), { status: value.bu_order_data.status }))), { trend, initPrice: (_a = value.bu_order_data.init_price) !== null && _a !== void 0 ? _a : 0, total_volume: (_b = value.bu_order_data.total_volume) !== null && _b !== void 0 ? _b : "0", total_fee: (_c = value.bu_order_data.total_fee) !== null && _c !== void 0 ? _c : "0", total_funding_fee: (_d = value.bu_order_data.total_funding_fee) !== null && _d !== void 0 ? _d : "0", total_realized_profit: (_e = value.bu_order_data.total_realized_profit) !== null && _e !== void 0 ? _e : "0", paired_volume: (_f = value.bu_order_data.paired_volume) !== null && _f !== void 0 ? _f : "0", paired_fee: (_g = value.bu_order_data.paired_fee) !== null && _g !== void 0 ? _g : "0", liquidation_triggered: (_h = value.bu_order_data.liquidation_triggered) !== null && _h !== void 0 ? _h : false, liquidation_price: (_j = value.bu_order_data.liquidation_price) !== null && _j !== void 0 ? _j : "", risk_status: value.bu_order_data.risk_status || undefined, margin_status: (_k = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _k === void 0 ? void 0 : _k.margin_status, innerStatus: value.bu_order_data.strategy_status, liquidation_fee: (_l = value.bu_order_data.liquidation_fee) !== null && _l !== void 0 ? _l : "", estimate_liquidation_price_up: (_m = value.bu_order_data.estimate_liquidation_price_up) !== null && _m !== void 0 ? _m : "", estimate_liquidation_price_down: (_o = value.bu_order_data.estimate_liquidation_price_down) !== null && _o !== void 0 ? _o : "", position: (_p = value.bu_order_data.position) !== null && _p !== void 0 ? _p : "0", position_open_price: (_q = value.bu_order_data.position_open_price) !== null && _q !== void 0 ? _q : "0", margin_balance: (_r = value.bu_order_data.margin_balance) !== null && _r !== void 0 ? _r : "0", extra_margin: (_s = value.bu_order_data.extra_margin) !== null && _s !== void 0 ? _s : "0", avgOpenPrice: avgOpenPrice, stop_loss_enabled: (_t = value.bu_order_data.stop_loss_enabled) !== null && _t !== void 0 ? _t : undefined, stop_profit_enabled: (_u = value.bu_order_data.stop_profit_enabled) !== null && _u !== void 0 ? _u : undefined, isRunning: exports.TradeUtils.handleState(exports.TradeUtils.convertState(value.bu_order_data.status, false)), timestamp: value.bu_order_data.create_time, closeTimestamp: value.bu_order_data.close_time, msg: value.bu_order_data.reason_by ? value.bu_order_data.reason_by : undefined, state: exports.TradeUtils.convertState(value.bu_order_data.status, false), loss_stop_delay: value.bu_order_data.loss_stop_delay ? value.bu_order_data.loss_stop_delay : "", loss_stop_type: value.bu_order_data.loss_stop_type || "", loss_stop: value.bu_order_data.loss_stop || "", profit_stop_delay: value.bu_order_data.profit_stop_delay ? value.bu_order_data.profit_stop_delay : "", profit_stop_type: value.bu_order_data.profit_stop_type || "", profit_stop: value.bu_order_data.profit_stop || "", trx_24h: Number(value.bu_order_data.trx_24h) || 0, trx_history: Number(value.bu_order_data.exchange_order_paired_count) || 0, base: value.bu_order_data.base, quote: value.bu_order_data.quote, openPositionBuyLimit: value.bu_order_data.open_position_buy_limit
                    ? Number(value.bu_order_data.open_position_buy_limit)
                    : undefined, openPositionSellLimit: value.bu_order_data.open_position_sell_limit
                    ? Number(value.bu_order_data.open_position_sell_limit)
                    : undefined, quote_investment: value.bu_order_data.quote_investment ? parseFloat(value.bu_order_data.quote_investment) : 0, unlock_quote_amount: (_v = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _v === void 0 ? void 0 : _v.unlock_quote_amount, leverage: Number((_w = value.bu_order_data.leverage) !== null && _w !== void 0 ? _w : 0) });
        }
        // TODO: hedge grid - 目前多空双开仅支持同币对 所以哪个有值取哪个
        data.base = ((_b = (_a = data.bu_order_data) === null || _a === void 0 ? void 0 : _a.long) === null || _b === void 0 ? void 0 : _b.base) || ((_d = (_c = data.bu_order_data) === null || _c === void 0 ? void 0 : _c.short) === null || _d === void 0 ? void 0 : _d.base);
        data.quote = ((_f = (_e = data.bu_order_data) === null || _e === void 0 ? void 0 : _e.long) === null || _f === void 0 ? void 0 : _f.quote) || ((_h = (_g = data.bu_order_data) === null || _g === void 0 ? void 0 : _g.short) === null || _h === void 0 ? void 0 : _h.quote);
        data.baseDisplay = exports.TradeUtils.parseBaseDisplay(data.base);
        const longData = formatTrendOrderData(Object.assign(Object.assign({}, data), { bu_order_data: (_j = data.bu_order_data) === null || _j === void 0 ? void 0 : _j.long }), TradeTypeDef_1.GridFuturesTrend.long);
        const shortData = formatTrendOrderData(Object.assign(Object.assign({}, data), { bu_order_data: (_k = data.bu_order_data) === null || _k === void 0 ? void 0 : _k.short }), TradeTypeDef_1.GridFuturesTrend.short);
        return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(data, "", false), {
            baseDisplay: exports.TradeUtils.parseBaseDisplay(data.base),
            exchangeGridV4FuturesHedgeGridOrder: {
                long: longData,
                short: shortData,
                total_volume: (_l = data.bu_order_data.total_volume) !== null && _l !== void 0 ? _l : "0",
                total_fee: (_m = data.bu_order_data.total_fee) !== null && _m !== void 0 ? _m : "0",
                total_funding_fee: (_o = data.bu_order_data.total_funding_fee) !== null && _o !== void 0 ? _o : "0",
                total_realized_profit: (_p = data.bu_order_data.total_realized_profit) !== null && _p !== void 0 ? _p : "0",
                margin_balance: (_q = data.bu_order_data.margin_balance) !== null && _q !== void 0 ? _q : "0",
                extra_margin: (_r = data.bu_order_data.extra_margin) !== null && _r !== void 0 ? _r : "0",
                quote_investment: (_s = data.bu_order_data.init_quote_investment) !== null && _s !== void 0 ? _s : "0",
                baseAmount: (_t = data.bu_order_data.base_amount) !== null && _t !== void 0 ? _t : "0",
                risk_status: data.bu_order_data.risk_status || undefined,
                margin_status: (_u = data === null || data === void 0 ? void 0 : data.bu_order_data) === null || _u === void 0 ? void 0 : _u.margin_status,
                trx_24h: new trade_utils_lib_1.SafeDecimal(((_w = (_v = data.bu_order_data) === null || _v === void 0 ? void 0 : _v.long) === null || _w === void 0 ? void 0 : _w.trx_24h) || 0).add(((_y = (_x = data.bu_order_data) === null || _x === void 0 ? void 0 : _x.short) === null || _y === void 0 ? void 0 : _y.trx_24h) || 0).toNumber(),
                trx_history: new trade_utils_lib_1.SafeDecimal(((_0 = (_z = data.bu_order_data) === null || _z === void 0 ? void 0 : _z.long) === null || _0 === void 0 ? void 0 : _0.exchange_order_paired_count) || 0)
                    .add(((_2 = (_1 = data.bu_order_data) === null || _1 === void 0 ? void 0 : _1.short) === null || _2 === void 0 ? void 0 : _2.exchange_order_paired_count) || 0)
                    .toNumber(),
                gridProfit: Number((_3 = data.bu_order_data.grid_profit) !== null && _3 !== void 0 ? _3 : 0),
                gridProfitOriginal: Number((_4 = data.bu_order_data.grid_profit) !== null && _4 !== void 0 ? _4 : 0),
                filledOrdersAmount: Number((_5 = data.bu_order_data.closed_exchange_order_count) !== null && _5 !== void 0 ? _5 : 0),
                transactionAmount: Number((_6 = data.bu_order_data.placed_exchange_order_count) !== null && _6 !== void 0 ? _6 : 0),
                loss_stop_delay: data.bu_order_data.loss_stop_delay ? data.bu_order_data.loss_stop_delay : "",
                loss_stop_type: data.bu_order_data.loss_stop_type || "",
                loss_stop: data.bu_order_data.loss_stop || "",
                profit_stop_delay: data.bu_order_data.profit_stop_delay ? data.bu_order_data.profit_stop_delay : "",
                profit_stop_type: data.bu_order_data.profit_stop_type || "",
                profit_stop: data.bu_order_data.profit_stop || "",
                profitWithdrawn: new trade_utils_lib_1.SafeDecimal((longData === null || longData === void 0 ? void 0 : longData.profitWithdrawn) || 0).add((shortData === null || shortData === void 0 ? void 0 : shortData.profitWithdrawn) || 0).toNumber(),
                initQuoteAmount: new trade_utils_lib_1.SafeDecimal((longData === null || longData === void 0 ? void 0 : longData.initQuoteAmount) || 0).add((shortData === null || shortData === void 0 ? void 0 : shortData.initQuoteAmount) || 0).toNumber(),
                estimate_liquidation_price_up: (_8 = (_7 = data.bu_order_data) === null || _7 === void 0 ? void 0 : _7.short) === null || _8 === void 0 ? void 0 : _8.estimate_liquidation_price_up,
                estimate_liquidation_price_down: (_10 = (_9 = data.bu_order_data) === null || _9 === void 0 ? void 0 : _9.long) === null || _10 === void 0 ? void 0 : _10.estimate_liquidation_price_down,
                msg: data.bu_order_data.status || undefined,
                isRunning: exports.TradeUtils.handleState(exports.TradeUtils.convertState((_12 = (_11 = data.bu_order_data) === null || _11 === void 0 ? void 0 : _11.long) === null || _12 === void 0 ? void 0 : _12.status, false)) ||
                    exports.TradeUtils.handleState(exports.TradeUtils.convertState((_14 = (_13 = data.bu_order_data) === null || _13 === void 0 ? void 0 : _13.short) === null || _14 === void 0 ? void 0 : _14.status, false)),
            },
        });
    },
    /**
     *
     * @param value
     * @param symbolInfo 该参数仅供手动订单使用
     */
    convertToExchangeOrder(value, symbolInfo) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74;
        if (!value) {
            return undefined;
        }
        if ((value.symbol || "").includes(".PERP/") &&
            [TradeTypeDef_1.ExchangeOrderType.post, TradeTypeDef_1.ExchangeOrderType.market_qty, TradeTypeDef_1.ExchangeOrderType.market_amt, TradeTypeDef_1.ExchangeOrderType.ats].includes(value.type)) {
            return {
                originOrderData: value,
            };
        }
        if (value.bu_order_type === TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid) {
            return exports.TradeUtils.gridV4FuturesHedgeGridToExchangeOrder({ data: value });
        }
        ///todo  symbolinfo 在推送时候为undefined，推送只有pionex 有,故下面可以指定交易所为pionex
        if (value.type === TradeTypeDef_1.ExchangeOrderType.limit || value.type === TradeTypeDef_1.ExchangeOrderType.market || value.type === TradeTypeDef_1.ExchangeOrderType.post) {
            const [base, quote] = value.symbol.split("/");
            const itemExchangeTradeInfo = exports.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
            const temp = exports.TradeUtils.parseDisplay(base, quote, ExchangeID_1.ExchangeID.PIONEXV2, itemExchangeTradeInfo === null || itemExchangeTradeInfo === void 0 ? void 0 : itemExchangeTradeInfo.futureTag);
            let tempBaseDisplay = base;
            let tempIsLeverage = false;
            if (symbolInfo !== undefined) {
                tempBaseDisplay = symbolInfo.baseDisplay;
                tempIsLeverage = symbolInfo.isLeverage;
            }
            else {
                tempBaseDisplay = temp.baseDisplay;
                tempIsLeverage = temp.isLeverage;
            }
            let fee = 0;
            let feeCoin = quote;
            if (value.fee && value.fee["currency"] && value.fee["cost"]) {
                fee = value.fee["cost"];
                feeCoin = value.fee["currency"];
            }
            let amount = Number(value.amount) === 0 ? value.filled : Math.min(value.amount, value.filled);
            let cost = value.cost ? value.cost : value.filled * value.price;
            const avgPrice = value.average ? value.average : cost / amount;
            return {
                id: value.id,
                orderType: value.type || TradeTypeDef_1.ExchangeOrderType.limit,
                base: base,
                quote: quote,
                symbol: value.symbol,
                baseDisplay: tempBaseDisplay,
                isLeverage: tempIsLeverage,
                timestamp: value.timestamp,
                lastTradeTime: value.lastTradeTimestamp || value.last_trade_timestamp || undefined,
                state: exports.TradeUtils.convertState(value.status, value.filled > 0),
                isRunning: exports.TradeUtils.handleState(exports.TradeUtils.convertState(value.status, value.filled > 0)),
                originOrderData: value,
                exchangeCustomOrder: {
                    side: value.side,
                    type: value.type,
                    price: Number((_a = value.price) !== null && _a !== void 0 ? _a : 0),
                    amount: Number((_b = value.amount) !== null && _b !== void 0 ? _b : 0),
                    avgDealPrice: Number(value.filled > 0 ? avgPrice : 0),
                    filled_amount: Number(amount !== null && amount !== void 0 ? amount : 0),
                    filled_value: Number(cost !== null && cost !== void 0 ? cost : 0),
                    fee: Number(fee !== null && fee !== void 0 ? fee : 0),
                    feeCoin: feeCoin.toUpperCase(),
                    source: "",
                },
            };
        }
        // FIX 解决相关字段不存在时会产生崩溃的问题
        if (!value.bu_order_data || !value.bu_order_type) {
            return undefined;
        }
        const itemExchangeTradeInfo = exports.TradeUtils.loadTradeExchangeInfo(value.exchange);
        const temp = exports.TradeUtils.parseDisplay(value.base, value.quote, value.exchange, itemExchangeTradeInfo === null || itemExchangeTradeInfo === void 0 ? void 0 : itemExchangeTradeInfo.futureTag);
        let baseDisplay = temp.baseDisplay;
        let isLeverage = temp.isLeverage;
        const buOrderDataKeys = Object.keys(value.bu_order_data);
        if (buOrderDataKeys.length === 0) {
            return undefined;
        }
        switch (value.bu_order_type) {
            case TradeTypeDef_1.ExchangeOrderType.grid: {
                return {
                    id: value.bu_order_id,
                    userId: value.user_id,
                    orderType: value.bu_order_type,
                    base: value.base,
                    quote: value.quote,
                    exchange: value.exchange,
                    baseDisplay: baseDisplay,
                    isLeverage: isLeverage,
                    symbol: (0, BaseTradingApi_1.toSymbol)(value.base, value.quote),
                    timestamp: value.create_time,
                    closeTimestamp: value.close_time ? value.close_time : 0,
                    state: exports.TradeUtils.convertState(value.status, false),
                    msg: value.bu_order_data.status ? value.bu_order_data.status : undefined,
                    key_id: value.key_id ? value.key_id : undefined,
                    isRunning: exports.TradeUtils.handleState(exports.TradeUtils.convertState(value.status, false)),
                    originOrderData: value,
                    exchangeGridOrder: (0, ParseOrderUtils_1._convertToGridOrderInfo)(value),
                };
            }
            case TradeTypeDef_1.ExchangeOrderType.gridClassic: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGridClassicOrder: (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV3: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGridV3Order: (0, ParseOrderUtils_1._convertGridV3ToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV4: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGridV4Order: (0, ParseOrderUtils_1._convertGridV4ToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV5: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGridV5Order: (0, ParseOrderUtils_1._convertGridV5ToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridV4Futures: {
                // margin_balance+（X - 开仓价）* 仓位=实际投资额+动态保证金
                // >>> X=开仓价+（实际投资额+动态保证金-margin_balance）/仓位
                const baseAmountD = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.base_amount);
                let avgOpenPrice = "";
                if (baseAmountD.eq(0) === false) {
                    const openPrice = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.position_open_price);
                    const invest = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.quote_investment);
                    const extraMargin = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.extra_margin);
                    const marginBalance = new trade_utils_lib_1.SafeDecimal(value.bu_order_data.margin_balance);
                    avgOpenPrice = invest.add(extraMargin).sub(marginBalance).div(baseAmountD).add(openPrice).toString();
                }
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGridV4FuturesOrder: Object.assign(Object.assign({}, (0, ParseOrderUtils_1._convertGridV3ToInnerOrderInfo)(value)), { initPrice: (_c = value.bu_order_data.init_price) !== null && _c !== void 0 ? _c : 0, total_volume: (_d = value.bu_order_data.total_volume) !== null && _d !== void 0 ? _d : "0", per_volume: (_e = value.bu_order_data.per_volume) !== null && _e !== void 0 ? _e : "0", total_fee: (_f = value.bu_order_data.total_fee) !== null && _f !== void 0 ? _f : "0", total_funding_fee: (_g = value.bu_order_data.total_funding_fee) !== null && _g !== void 0 ? _g : "0", total_realized_profit: (_h = value.bu_order_data.total_realized_profit) !== null && _h !== void 0 ? _h : "0", paired_volume: (_j = value.bu_order_data.paired_volume) !== null && _j !== void 0 ? _j : "0", paired_fee: (_k = value.bu_order_data.paired_fee) !== null && _k !== void 0 ? _k : "0", liquidation_triggered: (_l = value.bu_order_data.liquidation_triggered) !== null && _l !== void 0 ? _l : false, liquidation_price: (_m = value.bu_order_data.liquidation_price) !== null && _m !== void 0 ? _m : "", risk_status: value.bu_order_data.risk_status || undefined, liquidation_fee: (_o = value.bu_order_data.liquidation_fee) !== null && _o !== void 0 ? _o : "", estimate_liquidation_price_up: (_p = value.bu_order_data.estimate_liquidation_price_up) !== null && _p !== void 0 ? _p : "", estimate_liquidation_price_down: (_q = value.bu_order_data.estimate_liquidation_price_down) !== null && _q !== void 0 ? _q : "", position: (_r = value.bu_order_data.position) !== null && _r !== void 0 ? _r : "0", position_open_price: (_s = value.bu_order_data.position_open_price) !== null && _s !== void 0 ? _s : "0", quote_investment: (_t = value.bu_order_data.quote_investment) !== null && _t !== void 0 ? _t : "0", margin_balance: (_u = value.bu_order_data.margin_balance) !== null && _u !== void 0 ? _u : "0", extra_margin: (_v = value.bu_order_data.extra_margin) !== null && _v !== void 0 ? _v : "0", profit_stop_type: (_w = value.bu_order_data.profit_stop_type) !== null && _w !== void 0 ? _w : TradeTypeDef_1.GridStopType.price, loss_stop_type: (_x = value.bu_order_data.loss_stop_type) !== null && _x !== void 0 ? _x : TradeTypeDef_1.GridStopType.price, loss_stop_high: value.bu_order_data.loss_stop_high, avgOpenPrice: avgOpenPrice, share_ratio: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.share_ratio).toNumber(), shared_profit: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.shared_profit).toNumber(), stop_loss_enabled: value.bu_order_data.stop_loss_enabled, stop_profit_enabled: value.bu_order_data.stop_profit_enabled, openQuotePrice: value.bu_order_data.open_quote_price ? Number(value.bu_order_data.open_quote_price) : undefined, close_sell_model: (_y = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _y === void 0 ? void 0 : _y.close_sell_model, quote_sell_price: (_z = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _z === void 0 ? void 0 : _z.quote_sell_price, unlock_usdt_amount: (_0 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _0 === void 0 ? void 0 : _0.unlock_usdt_amount, unlock_quote_amount: (_1 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _1 === void 0 ? void 0 : _1.unlock_quote_amount, closed_quote_price: (_2 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _2 === void 0 ? void 0 : _2.closed_quote_price, quote_amount_sell: (_3 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _3 === void 0 ? void 0 : _3.quote_amount_sell, quote_amount_before_sell: (_4 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _4 === void 0 ? void 0 : _4.quote_amount_before_sell, margin_status: (_5 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _5 === void 0 ? void 0 : _5.margin_status, ui_invest_coin: (_6 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _6 === void 0 ? void 0 : _6.ui_invest_coin, invest_coin: (_7 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _7 === void 0 ? void 0 : _7.invest_coin, investment_from: (_8 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _8 === void 0 ? void 0 : _8.investment_from, lock_end_time: new trade_utils_lib_1.SafeDecimal((_9 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _9 === void 0 ? void 0 : _9.lock_end_time).toNumber(), profit_withdrawn_u: (_10 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _10 === void 0 ? void 0 : _10.profit_withdrawn_u, profit_withdrawn_c: (_11 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _11 === void 0 ? void 0 : _11.profit_withdrawn_c, profit_withdrawn_p: (_12 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _12 === void 0 ? void 0 : _12.profit_withdrawn_p, usdt_investment: (_13 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _13 === void 0 ? void 0 : _13.usdt_investment, locked_order: ((_14 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _14 === void 0 ? void 0 : _14.investment_from) === TradeTypeDef_1.GridFuturesInvestmentFrom.LOCK_ACTIVITY, trigger_pause_price_down: (_15 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _15 === void 0 ? void 0 : _15.trigger_pause_price_down, trigger_pause_price_up: (_16 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _16 === void 0 ? void 0 : _16.trigger_pause_price_up, profit_reduce: (_17 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _17 === void 0 ? void 0 : _17.profit_reduce, closed_base_amount: (_18 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _18 === void 0 ? void 0 : _18.closed_base_amount, close_order_type: (_19 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _19 === void 0 ? void 0 : _19.close_order_type, loss_stop_limit_price: (_20 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _20 === void 0 ? void 0 : _20.loss_stop_limit_price, loss_stop_limit_high_price: (_21 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _21 === void 0 ? void 0 : _21.loss_stop_limit_high_price, profit_stop_limit_price: (_22 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _22 === void 0 ? void 0 : _22.profit_stop_limit_price, slippage: (_23 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _23 === void 0 ? void 0 : _23.slippage, init_base_amount: (_24 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _24 === void 0 ? void 0 : _24.init_base_amount, bonus_id: (_25 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _25 === void 0 ? void 0 : _25.bonus_id, bonus_back_usdt: (_26 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _26 === void 0 ? void 0 : _26.bonus_back_usdt, bonus_back_quote: (_27 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _27 === void 0 ? void 0 : _27.bonus_back_quote, tpsl_close_pending: [TradeTypeDef_1.GridFuturesTPSLCloseOrderType.limitHigh, TradeTypeDef_1.GridFuturesTPSLCloseOrderType.limit].includes((_28 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _28 === void 0 ? void 0 : _28.close_order_type) && ((_29 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _29 === void 0 ? void 0 : _29.status) === TradeTypeDef_1.OrderInnerStatus.closePosition }),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridPro: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGridProOrder: (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridLeverage: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeLeverageGridOrder: (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridLoan: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeLoanGridOrder: (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridShort: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeShortGridOrder: (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridFuture: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeFutureGridOrder: Object.assign(Object.assign({}, (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value)), { marginCoin: value.bu_order_data.future_margin_coin, lockedMargin: Number((_30 = value.bu_order_data.future_locked_margin) !== null && _30 !== void 0 ? _30 : 0), lockedPosition: Number((_31 = value.bu_order_data.future_locked_position) !== null && _31 !== void 0 ? _31 : 0), futurePosition: Number((_32 = value.bu_order_data.future_position) !== null && _32 !== void 0 ? _32 : 0), realizedProfit: Number((_33 = value.bu_order_data.future_realized_profit) !== null && _33 !== void 0 ? _33 : 0), initMargin: Number((_34 = value.bu_order_data.future_init_margin) !== null && _34 !== void 0 ? _34 : 0), chargedMargin: Number((_35 = value.bu_order_data.future_charged_margin) !== null && _35 !== void 0 ? _35 : 0), futureFeeTotal: Number((_36 = value.bu_order_data.future_fee_total) !== null && _36 !== void 0 ? _36 : 0), marginReserve: Number((_37 = value.bu_order_data.future_margin_reserve) !== null && _37 !== void 0 ? _37 : 0), swapFeeTotal: Number((_38 = value.bu_order_data.swap_fee_total) !== null && _38 !== void 0 ? _38 : 0), realInitMargin: Number((_39 = value.bu_order_data.future_real_init_margin) !== null && _39 !== void 0 ? _39 : 0), realInitMarginDiff: Number((_40 = value.bu_order_data.future_real_init_margin_diff) !== null && _40 !== void 0 ? _40 : 0) }),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.gridLeverageShort: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeLeverageShortGridOrder: (0, ParseOrderUtils_1._convertToInnerOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.trailingStop: {
                return {
                    id: value.bu_order_id,
                    userId: value.user_id,
                    orderType: value.bu_order_type,
                    base: value.base,
                    quote: value.quote,
                    exchange: value.exchange,
                    baseDisplay: baseDisplay,
                    isLeverage: isLeverage,
                    symbol: (0, BaseTradingApi_1.toSymbol)(value.base, value.quote),
                    timestamp: value.create_time,
                    closeTimestamp: value.close_time ? value.close_time : 0,
                    state: exports.TradeUtils.convertState(value.status, false),
                    msg: value.bu_order_data.status ? value.bu_order_data.status : undefined,
                    key_id: value.key_id ? value.key_id : undefined,
                    isRunning: exports.TradeUtils.handleState(exports.TradeUtils.convertState(value.status, false)),
                    originOrderData: value,
                    exchangeTrailingStopLimitOrder: {
                        buy: value.bu_order_data.buy ? parseFloat(value.bu_order_data.buy) : 0,
                        trigger: value.bu_order_data.trigger ? parseFloat(value.bu_order_data.trigger) : 0,
                        amount: value.bu_order_data.amount ? parseFloat(value.bu_order_data.amount) : 0,
                        trailing_percentage: value.bu_order_data.trailing_percentage
                            ? parseFloat(value.bu_order_data.trailing_percentage)
                            : 0,
                        loss_stop: value.bu_order_data.loss_stop ? parseFloat(value.bu_order_data.loss_stop) : 0,
                        trailing_stop_profit: value.bu_order_data.trailing_stop_profit
                            ? parseFloat(value.bu_order_data.trailing_stop_profit)
                            : 0,
                        state: value.bu_order_data.status,
                        average_buy_price: value.bu_order_data.average_buy_price ? parseFloat(value.bu_order_data.average_buy_price) : 0,
                        buy_amount: value.bu_order_data.buy_amount ? parseFloat(value.bu_order_data.buy_amount) : 0,
                        profit_taken: value.bu_order_data.profit_taken ? parseFloat(value.bu_order_data.profit_taken) : 0,
                    },
                };
            }
            case TradeTypeDef_1.ExchangeOrderType.stopLimit: {
                return {
                    id: value.bu_order_id,
                    userId: value.user_id,
                    orderType: value.bu_order_type,
                    base: value.base,
                    quote: value.quote,
                    baseDisplay: baseDisplay,
                    isLeverage: isLeverage,
                    exchange: value.exchange,
                    symbol: (0, BaseTradingApi_1.toSymbol)(value.base, value.quote),
                    timestamp: value.create_time,
                    state: exports.TradeUtils.convertState(value.status, false),
                    key_id: value.key_id ? value.key_id : undefined,
                    isRunning: exports.TradeUtils.handleState(exports.TradeUtils.convertState(value.status, false)),
                    originOrderData: value,
                    exchangeStopLimitOrder: {
                        exchangeOrderIds: [],
                        side: value.bu_order_data.side,
                        type: value.bu_order_type,
                        price: Number((_41 = value.bu_order_data.limit) !== null && _41 !== void 0 ? _41 : 0),
                        amount: Number((_42 = value.bu_order_data.amount) !== null && _42 !== void 0 ? _42 : 0),
                        filled_amount: Number((_43 = value.bu_order_data.filled) !== null && _43 !== void 0 ? _43 : 0),
                        filled_value: 0,
                        stop: Number((_44 = value.bu_order_data.stop) !== null && _44 !== void 0 ? _44 : 0),
                        limit: Number((_45 = value.bu_order_data.limit) !== null && _45 !== void 0 ? _45 : 0),
                    },
                };
            }
            case TradeTypeDef_1.ExchangeOrderType.aip: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    msg: value.bu_order_data.error || undefined,
                    exchangeAIPOrder: {
                        canRetry: value.bu_order_data.can_retry === null ? false : value.bu_order_data.can_retry,
                        interval: Number((_46 = value.bu_order_data.interval) !== null && _46 !== void 0 ? _46 : 0),
                        investment: Number(value.bu_order_data.invested || 0),
                        lastInvestTime: Number(value.bu_order_data.last_invest_time || 0),
                        perVolume: Number((_47 = value.bu_order_data.per_volume) !== null && _47 !== void 0 ? _47 : 0),
                        side: value.bu_order_data.side,
                        traded: Number(value.bu_order_data.traded || 0),
                        traded_count: Number(value.bu_order_data.traded_count || 0),
                        profit: 0,
                        profitPercent: 0,
                    },
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.twap: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    msg: value.bu_order_data.error || undefined,
                    exchangeTWAPOrder: {
                        canRetry: value.bu_order_data.can_retry === null ? false : value.bu_order_data.can_retry,
                        interval: Number(value.bu_order_data.interval),
                        investment: Number((_48 = value.bu_order_data.invested) !== null && _48 !== void 0 ? _48 : 0),
                        lastInvestTime: Number((_49 = value.bu_order_data.last_invest_time) !== null && _49 !== void 0 ? _49 : 0),
                        totalVolume: Number((_50 = value.bu_order_data.total_volume) !== null && _50 !== void 0 ? _50 : 0),
                        totalTimes: Number((_51 = value.bu_order_data.total_times) !== null && _51 !== void 0 ? _51 : 0),
                        investCount: Number((_52 = value.bu_order_data.invest_count) !== null && _52 !== void 0 ? _52 : 0),
                        side: value.bu_order_data.side,
                        traded: Number((_53 = value.bu_order_data.traded) !== null && _53 !== void 0 ? _53 : 0),
                        traded_count: Number((_54 = value.bu_order_data.traded_count) !== null && _54 !== void 0 ? _54 : 0),
                        profit: 0,
                    },
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.ig: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeIGOrder: (0, ParseOrderUtils_1._convertToIGOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.SL_Pro: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeSLProOrder: {
                        side: value.bu_order_data.side,
                        type: value.bu_order_data.type,
                        condition: Number(value.bu_order_data.condition),
                        conditionDirection: value.bu_order_data.condition_direction,
                        triggerTime: value.bu_order_data.trigger_time ? value.bu_order_data.trigger_time : 0,
                        price: Number((_55 = value.bu_order_data.price) !== null && _55 !== void 0 ? _55 : 0),
                        amount: Number((_56 = value.bu_order_data.amount) !== null && _56 !== void 0 ? _56 : 0),
                        filled_amount: Number((_57 = value.bu_order_data.filled) !== null && _57 !== void 0 ? _57 : 0),
                        filled_value: Number((_58 = value.bu_order_data.cost) !== null && _58 !== void 0 ? _58 : 0),
                        latestPrice: 0,
                        fee: Number((_59 = value.bu_order_data.fee) !== null && _59 !== void 0 ? _59 : 0),
                        feeCoin: value.bu_order_data.side === TradeTypeDef_1.ExchangeOrderSide.buy ? value.base : value.quote,
                        avgDealPrice: Number((_60 = value.bu_order_data.average) !== null && _60 !== void 0 ? _60 : 0),
                        priceChange: 0,
                    },
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.smartTrade: {
                let totalInvest = 0;
                if (value.bu_order_data.smart_type === TradeTypeDef_1.SmartTradeType.smart_trade_sell_only) {
                    totalInvest = Number((_61 = value.bu_order_data.trigger) !== null && _61 !== void 0 ? _61 : 0) * Number((_62 = value.bu_order_data.amount) !== null && _62 !== void 0 ? _62 : 0);
                }
                else if (value.bu_order_data.smart_type === TradeTypeDef_1.SmartTradeType.smart_trade) {
                    if (Number((_63 = value.bu_order_data.buy) !== null && _63 !== void 0 ? _63 : 0) === 0) {
                        //市价
                        totalInvest = Number((_64 = value.bu_order_data.amount) !== null && _64 !== void 0 ? _64 : 0);
                    }
                    else {
                        //限价
                        totalInvest = Number((_65 = value.bu_order_data.buy) !== null && _65 !== void 0 ? _65 : 0) * Number((_66 = value.bu_order_data.amount) !== null && _66 !== void 0 ? _66 : 0);
                    }
                }
                else {
                    totalInvest = Number((_67 = value.bu_order_data.amount) !== null && _67 !== void 0 ? _67 : 0);
                }
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    msg: value.bu_order_data.error || undefined,
                    exchangeSmartTradeOrder: {
                        buy: Number((_68 = value.bu_order_data.buy) !== null && _68 !== void 0 ? _68 : 0),
                        trigger: Number((_69 = value.bu_order_data.trigger) !== null && _69 !== void 0 ? _69 : 0),
                        amount: Number((_70 = value.bu_order_data.amount) !== null && _70 !== void 0 ? _70 : 0),
                        trailingPercentage: Number((_71 = value.bu_order_data.trailing_percentage) !== null && _71 !== void 0 ? _71 : 0),
                        lossStop: Number((_72 = value.bu_order_data.loss_stop) !== null && _72 !== void 0 ? _72 : 0),
                        trailingStopProfit: Number((_73 = value.bu_order_data.trailing_stop_profit) !== null && _73 !== void 0 ? _73 : 0),
                        buyAmountFilled: value.bu_order_data.buy_amount_filled ? Number(value.bu_order_data.buy_amount_filled) : undefined,
                        profitTaken: value.bu_order_data.profit_taken,
                        recordHighPrice: value.bu_order_data.record_high_price ? Number(value.bu_order_data.record_high_price) : undefined,
                        sellPrice: value.bu_order_data.sell_price ? Number(value.bu_order_data.sell_price) : undefined,
                        latestPrice: 0,
                        totalInvest: totalInvest,
                        profit: 0,
                        profitPercent: 0,
                        buyCost: value.bu_order_data.buy_cost ? Number(value.bu_order_data.buy_cost) : undefined,
                        recordLowPrice: value.bu_order_data.record_low_price ? Number(value.bu_order_data.record_low_price) : undefined,
                        smartType: value.bu_order_data.smart_type,
                        trailingBuyPercent: value.bu_order_data.trailing_buy_percent
                            ? Number(value.bu_order_data.trailing_buy_percent)
                            : undefined,
                        convertCoin: (_74 = value.bu_order_data.convert_into_earn_coin) !== null && _74 !== void 0 ? _74 : false,
                    },
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.fsa: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeFSAOrder: (0, ParseOrderUtils_1._convertToFSAOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.cm_fsa: {
                const cmQuote = value.bu_order_data.settlement_coin && value.bu_order_data.settlement_coin !== ""
                    ? value.bu_order_data.settlement_coin
                    : value.quote;
                const cmTemp = exports.TradeUtils.parseDisplay(value.base, cmQuote, value.exchange, itemExchangeTradeInfo === null || itemExchangeTradeInfo === void 0 ? void 0 : itemExchangeTradeInfo.futureTag);
                return Object.assign(Object.assign(Object.assign({}, (0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, cmTemp.baseDisplay, cmTemp.isLeverage)), { quote: cmQuote }), {
                    exchangeCMFSAOrder: (0, ParseOrderUtils_1._convertToCMFSAOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.reverse_fsa: {
                const cmQuote = value.bu_order_data.settlement_coin && value.bu_order_data.settlement_coin !== ""
                    ? value.bu_order_data.settlement_coin
                    : value.quote;
                const cmTemp = exports.TradeUtils.parseDisplay(value.base, cmQuote, value.exchange, itemExchangeTradeInfo === null || itemExchangeTradeInfo === void 0 ? void 0 : itemExchangeTradeInfo.futureTag);
                return Object.assign(Object.assign(Object.assign({}, (0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, cmTemp.baseDisplay, cmTemp.isLeverage)), { quote: cmQuote }), {
                    exchangeReverseFSAOrder: (0, ParseOrderUtils_1._convertToReverseFSAOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.SR: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeSROrder: (0, ParseOrderUtils_1._convertToSROrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.martingale: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeMTGOrder: (0, ParseOrderUtils_1._convertToMTGOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.SC: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeSCOrder: (0, ParseOrderUtils_1._convertToSCOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.enhanced_aip: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeEnhancedAipOrder: (0, ParseOrderUtils_1._convertToEnhancedAipOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.bitfinex_certificate: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeBitfinexCertificateOrder: (0, ParseOrderUtils_1._convertToBitfinexCertificateOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.order_group: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeGroupOrder: (0, ParseOrderUtils_1._convertGroupOrderInfo)(value),
                });
            }
            case TradeTypeDef_1.ExchangeOrderType.futures_smart_trade: {
                return Object.assign((0, ParseOrderUtils_1._convertToExternalOrderInfo)(value, baseDisplay, isLeverage), {
                    exchangeFSTOrder: (0, FSTOrderUtils_1._convertFSTOrderInfo)(value),
                });
            }
            default: {
                return undefined;
            }
        }
    },
    getInnerOrder(exchangeOrder) {
        return exchangeOrder[orderTypeEnum[exchangeOrder.orderType]];
    },
    parseLeverageInfo(symbol) {
        if (!symbol.isLeverage) {
            return undefined;
        }
        const base = symbol.baseDisplay.substr(0, symbol.baseDisplay.length - 2);
        const leverage = symbol.baseDisplay.substr(symbol.baseDisplay.length - 2, 1);
        const isLong = symbol.baseDisplay.endsWith("L");
        return {
            base: base,
            leverage: leverage,
            isLong: isLong,
        };
    },
    getCurrencyBase(symbol) {
        var _a;
        let base = symbol.baseDisplay;
        if (symbol.isLeverage) {
            const _leverageInfo = exports.TradeUtils.parseLeverageInfo(symbol);
            base = (_a = _leverageInfo === null || _leverageInfo === void 0 ? void 0 : _leverageInfo.base) !== null && _a !== void 0 ? _a : base;
        }
        return base;
    },
};
